import { render, staticRenderFns } from "./goals_form.vue?vue&type=template&id=16257184&scoped=true&lang=html&"
import script from "./goals_form.vue?vue&type=script&lang=js&"
export * from "./goals_form.vue?vue&type=script&lang=js&"
import style0 from "./goals_form.vue?vue&type=style&index=0&id=16257184&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16257184",
  null
  
)

export default component.exports